module.exports = __webpack_public_path__ + "files/SPIADI2020 - Rapport OBSERVA4 provisoire - mai 2021.a7cc292f6ced75768cd5b8012edf14ff.pdf";